import React, { useEffect, useState } from 'react';
import { Alert, Button, Card, Form, Switch } from 'antd';
import StoreSettingService from "services/store_setting";
import { useForm } from "antd/es/form/Form";
import { useApp } from 'contexts/app';
import InputNumber from 'components/input-number';
const service = new StoreSettingService();

const CollaboratorSetting = () => {
    const [form] = useForm();
    const { showLoading, showNotify } = useApp();
    const [oldSetting, setOldSetting] = useState({})
    const commissionValue = Form.useWatch('commission', form);
    useEffect(() => {
        loadData();
    }, []);



    const loadData = async () => {
        var setting = await service.getCollaboratorSetting();
        form.setFieldsValue(setting);
        setOldSetting(setting);
    }

    const onFinish = async values => {
        // console.log('Success:', values);
        showLoading(true);
        await service.saveCollaboratorSetting(values)
        await loadData();
        showLoading(false);
        showNotify("Đã cập nhật")
    };
    const onFinishFailed = errorInfo => {
        console.log('Failed:', errorInfo);
    };
    return (

        <Card>
            <Form
                form={form}
                name="basic"
                layout='vertical'
                initialValues={{ remember: true }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
            >


                <Form.Item
                    label="Cho phép cộng tác viên"
                    name="collaborator"
                    rules={[{
                        required: true,

                    },

                    ]}
                    tooltip="Cho phép cộng tác viên tạo đơn hàng và hưởng hoa hồng"
                    valuePropName='checked'
                >
                  <Switch></Switch>
                </Form.Item>

                <Form.Item
                    label="Hoa hồng"
                    name="commission"
                    rules={[{
                        required: true,
                        message: "Vui lòng nhập tỉ lệ hoa hồng"
                    }, {
                        validator: (_, value) => {
                            if (value === undefined || value === null || value === "") {
                                return Promise.resolve();
                            }
                            if (typeof value !== "number" || Number.isNaN(value)) {
                                return Promise.reject(new Error("Tỉ lệ hoa hồng phải là số"));
                            }
                            if (value < 0) {
                                return Promise.reject(new Error("Tỉ lệ hoa hồng không được nhỏ hơn 0%"));
                            }
                            if (value > 100) {
                                return Promise.reject(new Error("Tỉ lệ hoa hồng không được lớn hơn 100%"));
                            }
                            return Promise.resolve();
                        }
                    }, {
                        warningOnly: true,
                        validator: (_, value) => {
                            if (typeof value === "number" && value < 5) {
                                return Promise.reject(new Error("Tỉ lệ dưới 5% là khá thấp, vui lòng kiểm tra lại"));
                            }
                            if (typeof value === "number" && value > 50) {
                                return Promise.reject(new Error("Tỉ lệ trên 50% là khá cao, vui lòng kiểm tra lại"));
                            }
                            return Promise.resolve();
                        }
                    }
                    ]}
                    tooltip="Tỉ lệ hoa hồng"
                >
                    <InputNumber min={0} max={100} placeholder="Nhập tỉ lệ % (0-100)" />
                </Form.Item>

                {typeof commissionValue === "number" && (commissionValue < 5 || commissionValue > 50) && (
                    <Alert
                        type="warning"
                        showIcon
                        style={{ marginBottom: 16 }}
                        message={commissionValue < 5 ? "Tỉ lệ hoa hồng đang ở mức thấp" : "Tỉ lệ hoa hồng đang ở mức cao"}
                        description={
                            commissionValue < 5
                                ? "Tỉ lệ thấp có thể làm giảm động lực của cộng tác viên. Hãy cân nhắc trước khi lưu."
                                : "Tỉ lệ cao có thể ảnh hưởng trực tiếp tới lợi nhuận đơn hàng. Hãy cân nhắc trước khi lưu."
                        }
                    />
                )}


                

                <Form.Item label={null}>
                    <Button type="primary" htmlType="submit">
                        Cập nhật
                    </Button>
                </Form.Item>
            </Form>

        </Card>
    )
}
export default CollaboratorSetting;